export const initAuthForm = () => {
    const $authRegisterForm = document.querySelector('.js-inline-auth-register-form');
    const $authRegisterAction = document.querySelector('.js-inline-auth-register');
    const $authRegisterInput = document.getElementById("registerInput");

    const $authLoginForm = document.querySelector('.js-inline-auth-login-form');
    const $authLoginActions = document.querySelectorAll('.js-inline-auth-login');
    const $authLoginInput = document.getElementById("loginInput");

    const $authPasswordForm = document.querySelector('.js-inline-auth-forgot-password-form');
    const $authPasswordAction = document.querySelector('.js-inline-auth-forgot-password');
    const $authPasswordInput = document.getElementById("forgotInput");

    if ($authRegisterAction) {
	    $authRegisterAction.addEventListener('click', event => {
			$authLoginForm.classList.remove('form-fade');

			setTimeout(function() {
				$authLoginForm.classList.add('form-hidden');
				$authRegisterForm.classList.remove('form-hidden');
			}, 150);

			setTimeout(function() {
				$authRegisterForm.classList.add('form-fade');
				$authRegisterInput.focus();
			}, 300);
		})
    }

    if($authLoginActions.length) {
	    $authLoginActions.forEach(el => {
	    	el.addEventListener('click', event => {
				if ($authRegisterForm.classList.contains('form-fade')) {
					$authRegisterForm.classList.remove('form-fade');
				}
				if ($authPasswordForm.classList.contains('form-fade')) {
					$authPasswordForm.classList.remove('form-fade');
				}

				setTimeout(function() {
					if (!$authRegisterForm.classList.contains('form-hidden')) {
						$authRegisterForm.classList.add('form-hidden');
					}
					if (!$authPasswordForm.classList.contains('form-hidden')) {
						$authPasswordForm.classList.add('form-hidden');
					}

					$authLoginForm.classList.remove('form-hidden');
				}, 150);

				setTimeout(function() {
					$authLoginForm.classList.add('form-fade');
					$authLoginInput.focus();
				}, 300);
			})
	 	})
    }

    if ($authPasswordAction) {
		$authPasswordAction.addEventListener('click', event => {
			$authLoginForm.classList.remove('form-fade');

			setTimeout(function() {
				$authLoginForm.classList.add('form-hidden');
				$authPasswordForm.classList.remove('form-hidden');
			}, 150);

			setTimeout(function() {
				$authPasswordForm.classList.add('form-fade');
				$authPasswordInput.focus();
			}, 300);
		})
	}
}
